import { dashboardT } from '../../../../lib/messages';
import type { TargetingFormValue } from '../../model';
import { InclusionToggle } from './InclusionToggle';
import type { TargetingFormUpdate } from './TargetingForm.types';
import { TargetingSection } from './TargetingSection';
import { TargetingTextarea } from './TargetingTextarea/TargetingTextarea';

export function ZipCodesTargetingSection({
  updateField,
  value,
}: {
  updateField: TargetingFormUpdate;
  value: TargetingFormValue;
}) {
  return (
    <TargetingSection
      title={dashboardT('targeting.zipCodes')}
      action={
        <InclusionToggle
          included={value.zipCodesIncluded}
          onIncludedChange={(included) => {
            updateField('zipCodesIncluded', included);
          }}
        />
      }
    >
      <TargetingTextarea
        aria-label={dashboardT('targeting.zipCodesAria')}
        copyLabel={dashboardT('targeting.zipCodesAria')}
        value={value.zipCodesText}
        onChange={(event) => {
          updateField('zipCodesText', event.target.value);
        }}
        placeholder={dashboardT('targeting.zipCodesPlaceholder')}
      />
    </TargetingSection>
  );
}
